import { render } from "./ElectrodeMeasurement.vue?vue&type=template&id=4b0a4c54&scoped=true"
import script from "./ElectrodeMeasurement.vue?vue&type=script&lang=js"
export * from "./ElectrodeMeasurement.vue?vue&type=script&lang=js"

import "./ElectrodeMeasurement.vue?vue&type=style&index=0&id=4b0a4c54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0a4c54"]])

export default __exports__